module.exports = __webpack_public_path__ + "static/img/pic_szh_zhptyy_ny_lb2@2x.0de5b6ac.png";